<template>
  <div class="header">
    <div class="top">
      <div class="top-content">
        <div>您好，欢迎访问宁东工业超市电子商务平台</div>
        <div>
          <!-- 投诉建议入口隐藏  -->
          <!-- <span
            v-if="haveToken"
            class="company-name pointer mr-30"
            @click="toFeedback"
          >
            投诉建议反馈
          </span> -->
          <span
            v-if="haveToken"
            class="company-name pointer mr-30"
            @click="toUserInfo"
          >
            个人中心
          </span>
          <span v-else class="company-name pointer mr-30" @click="toLogin">
            登录
          </span>
          <el-dropdown
            v-show="haveToken || $store.state.user.name"
            class="mr-30"
          >
            <span class="company-name pointer">
              {{ $store.state.user.name
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="logoutHandle()">{{
                $t("header.exit")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            class="header-top-company-dropdown"
            v-show="
              $store.state.user.companyAccountInfo &&
              $store.state.user.companyAccountInfo.length
            "
            placement="top-start"
            trigger="click"
          >
            <span class="company-name pointer">
              {{ $store.state.user.defaultCompanyName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu
              slot="dropdown"
              :model="companyList"
              class="dropdown-menu"
            >
              <el-input
                class="company-input"
                :placeholder="$t('header.companyName')"
                clearable
                v-if="$store.state.user.companyAccountInfo.length > 5"
                v-model.trim="dropdownCompanyName"
              >
              </el-input>
              <i
                class="el-icon-search"
                v-if="
                  $store.state.user.companyAccountInfo.length > 5 &&
                  dropdownCompanyName.length < 1
                "
              ></i>
              <el-dropdown-item
                v-for="item in companyList"
                :key="item.companyId"
              >
                <div class="company-item company-name">
                  <el-tooltip
                    placement="bottom"
                    effect="light"
                    :disabled="!tooltipFlag"
                    :enterable="false"
                  >
                    <div slot="content">
                      {{ item.companyName }}
                    </div>

                    <div
                      class="ellipsis flex-grow"
                      @click.stop="changeCompany(item)"
                      @mouseenter="handleTooltipIn($event)"
                      @mouseleave="handleTooltipOut($event)"
                    >
                      {{ item.companyName }}
                    </div>
                  </el-tooltip>
                  <div class="flex-shrink" @click.stop="changeCompany(item)">
                    {{
                      item.companyId === item.defaultCompanyId
                        ? $t("header.memberCenter")
                        : $t("header.switch")
                    }}
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="logoArea">
        <router-link to="/">
          <img class="logo" :src="logoUrl" alt="logo" />
        </router-link>
      </div>
      <div class="flex">
        <div class="searchArea">
          <div class="searchInput-box">
            <div class="center">
              <img
                class="searchIcon"
                src="~@/assets/img/main/search_icon.png"
                alt="search icon"
              />
            </div>
            <el-autocomplete
              class="searchInput fl"
              v-model="searchName"
              :popper-class="
                whiteListAutocomplete.includes($route.name)
                  ? ''
                  : 'autocomplete-hidden'
              "
              :fetch-suggestions="querySearch"
              :placeholder="$t('header.searchPlaceholder')"
              :trigger-on-focus="false"
              :select-when-unmatched="true"
              @select="searchByChoosed"
            >
              <template slot-scope="{ item }">
                <span v-html="item.name" class="search-list"></span>
              </template>
            </el-autocomplete>
            <div class="searchButton" @click="searchByInput">搜索</div>
          </div>
          <div class="search-keys">
            <div
              class="flex-align-center"
              v-for="(item, index) in popuCategory"
              :key="item.foregroundCategoryId"
            >
              <div
                class="searchSmall cursor-pointer ellipsis"
                @click="jumpj(item.foregroundCategoryId)"
              >
                {{ item.name }}
              </div>
              <span
                class="search-keys-line"
                v-if="index < popuCategory.length - 1"
                >|</span
              >
            </div>
          </div>
        </div>
        <div style="width:162px">
          <!-- <img
            @click="goAIMaterial"
            width="162px"
            style="margin-top: 3px"
            class="pointer"
            src="~@/assets/img/AI/material_btn.png"
            alt="AI物料助手"
          /> -->
        </div>
        <div style="width:180px">
          <!-- <img
            @click="goInquiry"
            width="180px"
            class="pointer"
            src="~@/assets/img/main/xxxj_btn.png"
            alt="选型询价"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { getEnvConfig } from '@/utils/envConfig.js'
import { getAccessToken } from '@/utils/userInfo'
import { clearLoginInfo } from '@/utils'
import defLogoImg from '@/assets/img/main/logo.png'
export default {
  data () {
    return {
      searchName: '',
      whiteListAutocomplete: [
        'goodDetail',
        'main',
        'goodSearchCategoryList',
        'goodCategoryList',
        'selectionCategoryList',
        'selectionInquiryDetail'
      ],
      dropdownCompanyName: '',
      tooltipFlag: false,
      popuCategory: [] // 热搜类目
    }
  },
  created () {
    this.bus.$on('setHeaderSearchName', (searchName) => {
      this.searchName = searchName
    })
    this.getPopularCategory()
  },
  computed: {
    logoUrl () {
      return defLogoImg
    },
    companyList () {
      let list = this.$store.state.user.companyAccountInfo
      //   console.log("companyList", list);

      if (list.length === 0) {
        return list
      } else if (this.dropdownCompanyName.length < 2) {
        return list
      } else {
        return list.filter(
          (item) =>
            item.companyName
              .toLowerCase()
              .indexOf(this.dropdownCompanyName.toLowerCase()) !== -1
        )
      }
    },
    haveToken () {
      let token = getAccessToken()
      let result = false
      if (token && token !== 'null' && token !== 'undefind' && token !== '') {
        result = true
      }
      return result
    }
  },
  methods: {
    toFeedback () {
      this.$router.push({
        name: 'feedback'
      })
    },
    // 获取最热类目
    getPopularCategory () {
      this.$request
        .get(`/front/cross/commodity-center/search/category-list`)
        .then((res) => {
          console.log('getPopularCategory', res)

          this.popuCategory = res || []
        })
    },
    jumpj (id) {
      // let jumpName = "goodCategoryList";
      // if (this.menuTypes === "selectionInquiry") {
      //   jumpName = "selectionCategoryList";
      // }
      this.$router.push({
        name: 'goodCategoryList',
        query: {
          foregroundCategoryId: id,
          brandIdList: '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    },
    // 切换公司
    changeCompany (item) {
      console.log('changeCompany')

      if (item.resignFlag === true) {
        // 已离职
        this.$confirm(this.$t('navbar.leave'), this.$t('prompt.title'), {
          confirmButtonText: this.$t('confirm'),
          showCancelButton: false,
          type: 'warning'
        })
          .then(() => {})
          .catch(() => {})
        return
      }
      if (item.companyId === item.defaultCompanyId) {
        // 跳转会员中心
        this.$router.push({
          name: 'basicInfo'
        })
      } else {
        this.$store.commit('company', item)
        // 切换默认公司
        this.$store.commit('setLoadStatus', true)
        this.$http
          .post(`/front/consumer/usercenter/updateDefCompanyId`, {
            companyId: item.companyId
          })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            // 请求新用户数据
            this.$http
              .get('/front/consumer/usercenter/custUserCenterInfo', {
                params: {
                  appCode: 'PLANTMATE_OFFICIAL',
                  companyId: item.companyId
                }
              })
              .then(({ data: res }) => {
                if (res.code !== 0) {
                  return false
                }
                // 设置用户信息
                this.$store.dispatch(
                  'companyList',
                  res.data.companyAccountInfo || []
                )
                this.$store.dispatch('setUserInfo', res.data.userInfo)
                Cookies.set('userId', res.data.userInfo.userId)
                Cookies.set('mobile', res.data.userInfo.mobile)

                // 获取生态服务用户数据
                this.getEcologyUserInfo(res.data.userInfo.userId)
                this.getCorpUser()

                // 重新请求用户菜单，关闭loading，切换到个人中心
                // this.bus.$emit('getUserMenuPerm')
                window.SITE_CONFIG['menuList'] = []
                this.$store.commit('setMenuList', [])
                console.log('切换公司0')
                this.$http
                  .get(
                    `/front/consumer/menu/bar/${window.SITE_CONFIG['appCode']}`
                  )
                  .then(({ data: res }) => {
                    if (res.code !== 0) {
                      return false
                    }
                    window.SITE_CONFIG['menuList'] = res.data.tree
                    this.$store.commit('setMenuList', res.data.tree)
                    window.SITE_CONFIG['permissions'] = res.data.api
                    // 判断有无 订单列表 有则跳，没有则跳到首页
                    this.$store.commit('setLoadStatus', false)
                    // 个人中心应该返回的路由权限集合
                    const routeMaps = [
                      'InvitationRegister',
                      'myPT',
                      'myShopCart',
                      'organization',
                      'NeedSendOrders',
                      'ShareDownload',
                      'MyWorkbench',
                      'integralManagment',
                      'signIn',
                      'equipmentList',
                      'basicInfo',
                      'selfOperation',
                      'rdmsOrderList',
                      'onlineService',
                      'orderList',
                      'solveSonsultList',
                      'serviceSonsultList',
                      'myInquiryCart',
                      'inquiryList',
                      'ShopCart',
                      'DailyBonus',
                      'examList',
                      'myAnswer',
                      'myInvitation',
                      'buyInvite',
                      'myBought',
                      'myCoupon',
                      'CourseHistory',
                      'myStudy',
                      'studyStatistics',
                      'liveTraining',
                      'myCollection',
                      'mySubscribe',
                      'myUpload',
                      'myDownload',
                      'myComment',
                      'myEvaluate',
                      'myQuestions',
                      'myAdvice',
                      'sparePartsLibrary',
                      'spareRequirementsList',
                      'spareGetList',
                      'spareStatementList',
                      'demandManage',
                      'securityConsole'
                    ]
                    // 新增个性化页面的详情页集合，遇到这些页面时直接调整首页
                    const personalMaps = [
                      'spareRequirementsDetail',
                      'spareGetDetail',
                      'orderDetail',
                      'spareRequirementsUpdate',
                      'spareGetDetailUpdate',
                      'orderPay',
                      'demandDetail'
                    ]
                    console.log('切换公司')

                    // 筛选出当前有的路由权限
                    const keymap =
                      res.data.tree &&
                      res.data.tree
                        .filter(
                          (res) =>
                            res.children && res.children.length && res.showLeft
                        )
                        .map((res) => res.children)
                        .flat()
                        .map((res) => res.menuUrl)
                    /**
                     * 如果当前页面属于个性化页面，比如商品详情页，此时直接跳转首页
                     * 如果当前页面包含在固定路由权限集合中
                     * 则进一步判断当前账号有无其中的路由权限(拿到账号路由权限进行匹配判断)
                     * 如果有其中的权限，则刷新当前页面，让页面刷新
                     * 如果没有权限，则跳转到首页
                     * 如果当前页面并不需要权限判断，则直接刷新当前页面即可
                     */
                    if (personalMaps.includes(this.$route.name)) {
                      this.$router.push({ name: 'main' })
                    } else if (routeMaps.includes(this.$route.name)) {
                      if (keymap && keymap.includes(this.$route.name)) {
                        this.$store.commit('resetRefresh', false)
                        this.$nextTick(() => {
                          this.$store.commit('resetRefresh', true)
                        })
                      } else {
                        this.$router.push({ name: 'main' })
                      }
                    } else {
                      this.$store.commit('resetRefresh', false)
                      this.$nextTick(() => {
                        this.$store.commit('resetRefresh', true)
                      })
                    }
                    this.bus.$emit('companyResetRefresh')
                    this.$message.success(this.$t('navbar.switchSuccess'))
                    window.location = '/'
                  })
                  .catch(() => {})
              })
              .catch(() => {})
          })
          .catch(() => {})
      }
    },
    getEcologyUserInfo (userId) {
      return this.$http
        .get(`/front/oms/supplier/User/getSsoUserInfoByUserId/${userId}`)
        .then(({ data: res }) => {
          if (res.code == 0) {
            // 手动修改用户类型
            // res.data.userType = 2
            this.$store.commit('setEcologyUserInfo', res.data)
          }
        })
    },
    getCorpUser () {
      return this.$http
        .get('/front/sys/crop-site/customer-crop-site')
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.commit('setCorpUserInfo', res.data || {})
          }
        })
    },
    // 设置超出隐藏的展示tootip
    handleTooltipIn (event) {
      this.tooltipFlag = event.target.scrollWidth > event.target.offsetWidth
    },
    handleTooltipOut () {
      this.tooltipFlag = false
    },
    goAIMaterial () {
      this.$router.push({
        name: 'chatHome'
      })
    },
    goInquiry () {
      this.$router.push({ name: 'meterSelectionIndex' })
    },
    searchByInput () {
      if (this.$route.path === '/sparePartsLibrary') {
        this.bus.$emit('getUserStoreSpare', this.searchName)
      } else if (this.$route.path === '/courseList') {
        this.bus.$emit('getUserCourseList', this.searchName)
      } else if (this.$route.path === '/onlineTraining') {
        Cookies.set('getUserCourseListindex', '1')
        Cookies.set('searchName', this.searchName)
        this.$router.push({
          name: 'courseList'
        })
      } else if (
        ['selectionCategoryList', 'selectionInquiryDetail'].includes(
          this.$route.name
        )
      ) {
        if (this.$route.query.search === this.searchName) return
        this.$router
          .push({
            name: 'selectionCategoryList',
            query: {
              search: this.searchName || ''
            }
          })
          .then(() => {
            this.searchName = this.$route.query.search
          })
      } else {
        if (this.$route.query.search === this.searchName) {
          this.$router.push({
            name: 'goodnull',
            query: {
              search: this.searchName,
              foregroundCategoryId: '',
              brandIdList: '',
              seriesIdList: '',
              attributeValueIdList: '',
              salesDesc: false,
              priceDesc: false,
              popularityDesc: false
            }
          })
          return
        }
        if (this.searchName) {
          this.$router.push({
            name: 'goodSearchCategoryList',
            query: {
              search: this.searchName,
              foregroundCategoryId: '',
              brandIdList: '',
              seriesIdList: '',
              attributeValueIdList: '',
              salesDesc: false,
              priceDesc: false,
              popularityDesc: false
            }
          })
        } else {
          this.$router.push({
            name: 'goodSearchCategoryList',
            query: {
              search: '',
              foregroundCategoryId: '',
              brandIdList: '',
              seriesIdList: '',
              attributeValueIdList: '',
              salesDesc: false,
              priceDesc: false,
              popularityDesc: false
            }
          })
        }
      }
    },
    searchByChoosed (val) {
      let divv = document.createElement('div')
      divv.innerHTML = val.name
      if (!val.spuId) {
        this.searchByInput()
      } else {
        this.searchName = divv.innerText
        // 选型和正常商品区分
        this.$router.push({
          name: ['selectionCategoryList', 'selectionInquiryDetail'].includes(
            this.$route.name
          )
            ? 'selectionInquiryDetail'
            : 'goodDetail',
          query: {
            spuId: val.spuId
          }
        })
      }
      divv = null
    },
    querySearch (queryString, cb) {
      let list = []
      if (this.whiteListAutocomplete.includes(this.$route.name)) {
        this.$http
          .get(`/front/cross/commodity-user/web/spu-name/list`, {
            params: {
              search: queryString,
              spuType: [
                'selectionCategoryList',
                'selectionInquiryDetail'
              ].includes(this.$route.name)
                ? 'lectotype'
                : undefined
            }
          })
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (res.data && res.data.length > 0) {
                cb(res.data)
              } else {
                cb(list)
              }
            } else {
              cb(list)
            }
          })
      } else {
        cb(list)
      }
    },
    // 退出
    logoutHandle () {
      this.$confirm(
        this.$t('prompt.info', { handle: this.$t('logout') }),
        this.$t('prompt.title'),
        {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          // let tok = ''
          // if (
          //   getAccessToken() &&
          //   getAccessToken() !== 'undefind' &&
          //   getAccessToken() !== 'null'
          // ) {
          //   tok = getAccessToken()
          // }
          this.$http
            .delete(
              `/auth/user/token?access_token=${getAccessToken()}&env=${
                getEnvConfig().env
              }&domain=${getEnvConfig().domain}&appCode=PLANTMATE_OFFICIAL`,
              {
                access_token: getAccessToken()
              }
            )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              clearLoginInfo()
              this.$router.push({ name: 'login' })
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    toUserInfo () {
      this.$router.push({
        name: 'basicInfo'
      })
    },
    toLogin () {
      this.$router.push({
        name: 'login'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  min-width: calc(100vw - 56px);
  height: 136px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Alibaba PuHuiTi;
  .center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1190px;
  }

  .searchInput-box {
    position: relative;
    display: flex;
    background: #ffffff;
    border: 2px solid #2a54d166;
    width: 588px;
    padding: 4px 4px 4px 16px;
    border-radius: 16px;
  }

  .searchInput {
    // width: 486px;
    flex: 1;
    /deep/.el-input__inner {
      height: 38px;
      border-radius: 25px;
      border: none;
      padding: 0 8px;
      &:focus {
        border: none;
      }
      &::placeholder {
        color: #cccccc;
      }
    }
  }
  .searchIcon {
    width: 16px;
    height: 16px;
  }
  .searchButton {
    background: #2a54d1;
    width: 88px;
    height: 40px;
    line-height: 8px;
    text-align: center;
    padding: 16px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
  .top {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    // background: #fff;
    font-family: Alibaba PuHuiTi;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    color: #333;
    flex-shrink: 0;
    .top-content {
      width: 1190px;
      display: flex;
      height: 40px;
      align-items: center;
      justify-content: space-between;
    }
    .company-name {
      font-family: Alibaba PuHuiTi;
      font-size: 12px;
      font-weight: 400;
      line-height: 12px;
      text-align: left;
      color: #333;
    }
  }
  .logoArea {
    width: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    .logo {
      height: 50px;
      width: auto;
      max-width: 240px;
    }
  }
}
.dropdown-menu {
  max-height: 480px;
  height: auto;
  overflow: auto;

  .company-input {
    border-radius: 2px !important;
    width: 85% !important;
    padding: 5px 0 10px 10px;
    margin-left: 10px;
  }

  .el-icon-search {
    position: relative;
    right: 25px;
    font-size: 15px;
  }

  .company-item {
    display: flex;
    width: 260px;
    justify-content: space-between;
    font-family: Alibaba PuHuiTi;
  }
}
.mr-30 {
  margin-right: 30px;
}

.searchArea {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 14px;

  .searchSmall {
    display: inline-block;
    font-size: 12px;
    color: #969799;
    max-width: 100px;
  }
  .search-keys {
    margin-top: 6px;
    display: flex;
    flex-wrap: nowrap;
    width: 588px;
  }
  .search-keys-line {
    margin-left: 4px;
    margin-right: 6px;
    color: #edf0f2;
  }
}
.flex-align-center {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss">
.autocomplete-hidden {
  display: none;
}

.el-tooltip__popper {
  pointer-events: none !important;
}
</style>
